import type { ReactElement } from 'react';

import { UserPopover } from '@bonusly/common-user-popover';
import { forwardRef, PopoverProps } from '@bonusly/design-system';
import { Recipient } from '@bonusly/recipient-entities';

import { GroupPopover } from './group-popover';

export interface RecipientPopoverProps extends PopoverProps {
	children: ReactElement;
	recipient?: Recipient;
	isDisabled?: boolean;
	isExpandable?: boolean;
	onExpand?: (users: Recipient[]) => void;
}

const RecipientPopover = forwardRef(({ children, recipient, isExpandable, onExpand, ...rest }: RecipientPopoverProps, ref) => {
	if (!recipient) return null;

	if (recipient.type === 'group') {
		return (
			<GroupPopover group={recipient} isExpandable={isExpandable} onExpand={onExpand} ref={ref} {...rest}>
				{children}
			</GroupPopover>
		);
	}
	return (
		<UserPopover userId={recipient.id} {...rest}>
			{children}
		</UserPopover>
	);
});

RecipientPopover.displayName = 'RecipientPopover';

export { RecipientPopover };
